import FilterTitle from "./FilterTitle";
import { useTranslation } from "next-i18next";
import { AutoComplete, message } from "antd";
import { useState } from "react";
import { DownOutlined } from "@ant-design/icons";

/**
 * 梦想值查询
 * @returns 梦想值查询组件
 */
const DreamValueFilter = ({
  onChange,
  hideTitle = false,
}: {
  onChange: (priceArr: (number | null)[]) => void;
  hideTitle?: boolean;
}) => {
  const { t } = useTranslation();
  const [minPrice, setMinPrice] = useState<number | null>(null);
  const [maxPrice, setMaxPrice] = useState<number | null>(null);
  const [minOpen, setMinOpen] = useState(false);
  const [maxOpen, setMaxOpen] = useState(false);

  const minPriceOptions = [0, 2500, 5000, 10000, 50000].map((val) => ({
    value: val.toString(),
  }));
  const maxPriceOptions = [2500, 5000, 10000, 50000].map((val) => ({
    value: val.toString(),
  }));

  const parseNumber = (val: string | undefined): number | null => {
    if (val == null || val.trim() === "") return null;
    const num = Number(val);
    return isNaN(num) ? null : num;
  };

  const handleBlur = () => {
    if (minPrice !== null && maxPrice !== null && minPrice >= maxPrice) {
      message.error(t("product_category.max_gt_min"));
      return;
    }
    onChange([minPrice, maxPrice]);
  };

  return (
    <div className="mb-8 flex w-full flex-col border-0 border-gray-100 lg:mb-0 lg:border-0 lg:px-0 lg:py-0">
      {!hideTitle && <FilterTitle title={t("common.dream_value")} />}
      <div className="dream-value-filter flex">
        <div className="flex flex-col">
          <AutoComplete
            style={{ width: 100 }}
            options={minPriceOptions}
            placeholder={t("product_category.lower_limit")}
            value={minPrice !== null ? String(minPrice) : undefined}
            onChange={(val) => {
              setMinPrice(parseNumber(val));
            }}
            onBlur={handleBlur}
            filterOption={(inputValue, option) => {
              if (!option || !option.value) return false;
              return option.value
                .toLowerCase()
                .includes(inputValue.toLowerCase());
            }}
            allowClear
            suffixIcon={
              <DownOutlined
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setMinOpen(!minOpen);
                }}
              />
            }
            open={minOpen}
            onOpenChange={(visible) => setMinOpen(visible)}
          />
        </div>
        <div className="mt-1 text-stone-500 mx-2"> - </div>
        <div className="flex flex-col">
          <AutoComplete
            style={{ width: 100 }}
            options={maxPriceOptions}
            placeholder={t("product_category.upper_limit")}
            value={maxPrice !== null ? String(maxPrice) : undefined}
            onChange={(val) => {
              setMaxPrice(parseNumber(val));
            }}
            onBlur={handleBlur}
            filterOption={(inputValue, option) => {
              if (!option || !option.value) return false;
              return option.value
                .toLowerCase()
                .includes(inputValue.toLowerCase());
            }}
            allowClear
            suffixIcon={
              <DownOutlined
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setMaxOpen(!maxOpen);
                }}
              />
            }
            open={maxOpen}
            onOpenChange={(visible) => setMaxOpen(visible)}
          />
        </div>
      </div>
    </div>
  );
};

export default DreamValueFilter;